export default $client => ({
  get() {
    return $client.get('coins');
  }
});
